import { BrandChatStorefrontContext } from '@storefronts/common-types'
import { createContext, useEffect, useState } from 'react'
import { getSellingBrief } from '../../../api'
import { BrandChatMessageInput } from '../../analytics/tracking'

export type BrandChatControls = {
    brief: BrandChatStorefrontContext | null
    /** Opens the chat and asks this question for the shopper. */
    ask: (question: string, input: BrandChatMessageInput) => void
}

/** Null outside a storefront that shows the brand chat. */
export const BrandChatContext = createContext<BrandChatControls | null>(null)

export const useSellingBrief = (
    landingPageHash: string,
    enabled: boolean,
): BrandChatStorefrontContext | null => {
    const [brief, setBrief] = useState<BrandChatStorefrontContext | null>(null)
    useEffect(() => {
        if (!enabled) return
        const controller = new AbortController()
        getSellingBrief(landingPageHash, controller.signal)
            .then(setBrief)
            .catch(() => setBrief(null))
        return () => controller.abort()
    }, [landingPageHash, enabled])
    return brief
}
